import React from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { isComingSoon } from '../constants'
import ComingSoonChip from './ComingSoonChip'

/**
 * One ticked feature, with its Coming soon chip when it has not shipped.
 *
 * The tick sits outside the wrapping text: on a narrow screen the text and chip wrap under each
 * other, never under the tick.
 */
function FeatureRow({ feature }: { feature: string }) {
  return (
    <li className='flex items-start gap-2 text-13 leading-snug text-ink-700'>
      <CheckCircleIcon
        sx={{ fontSize: 20 }}
        className='mt-px shrink-0 text-success'
      />
      <span className='flex flex-wrap items-center gap-2'>
        {feature}
        {isComingSoon(feature) && <ComingSoonChip />}
      </span>
    </li>
  )
}

export default FeatureRow
